import { apApi } from 'services/api/instances';

export type { ApiConfig } from 'services/api/defineApi';

// Backward-compatible boot API for the AP (default) client.
export const configureApiClient = apApi.configure;
export const getConfig = apApi.getConfig;
